<template>
  <b-button
    href="#"
    class="nav-link badge-warning"
    style="color: black"
    data-toggle="modal"
    v-b-modal="'indicar'"
    title="Indicação de Serviços"
  >
    <span class="d-flex align-items-center justify-content-center">
      <i class="nav-icon fas fa-share mr-2"></i>
      <span>Indicar Serviço</span>
    </span>
  </b-button>
</template>

<script>
export default {};
</script>
